module.exports = __webpack_public_path__ + "static/media/twitter-icon.7fbbf80e.svg";